var map = {
	"../pages/first-start/first-start.module": [
		1097,
		2
	],
	"../pages/search-on-deezer/search-on-deezer.module": [
		1095,
		1
	],
	"../pages/whats-next/whats-next.module": [
		1096,
		0
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 388;
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src lazy
// module id = 388
// module chunks = 3